<div id="tLoader" class="teiasoft-loader" style="display: none;" [style.top.px]="top">
    <img [src]="spinnerImage" class="tl-spinner">
</div>
